import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { BaseCommonService } from "@apps/patient-core/src/app/services/abstracts/common.service";
import { logger } from "@dentally/ui/logger";

@Injectable({
  providedIn: "root",
})
export class PortalV2RedirectGuard {
  constructor(private _commonService: BaseCommonService) {}

  public async canActivate(): Promise<boolean> {
    try {
      this._commonService.getCommonData();

      if (!this._commonService.isCommonDataLoaded) {
        await firstValueFrom(this._commonService.onInitData);
      }

      const redirectUrl = this._commonService.practice?.portalV2RedirectUrl;

      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return false;
      }
    } catch (error) {
      logger.error("Failed to resolve Portal V2 redirect, continuing on Portal V1", error);
    }

    return true;
  }
}
